import BaseObject from './BaseObject';
import Occasion from '@repo/utils/helpers/Occasion';
import Contact from './Contact';
import { ID } from '../types';
import { Set } from 'immutable';

export default class Duplicate extends BaseObject {
  created: Occasion;
  contacts: Contact[];
  score: number;
  isMerging: boolean;
  isTransitioningOut: boolean;

  constructor(props: any = {}) {
    super(props);
    this.created = new Occasion(props.created);
    this.contacts = props.contacts;
    this.score = props.score;
    this.isMerging = !!props.isMerging;
    this.isTransitioningOut = !!props.isTransitioningOut;
  }

  get contactIDs(): Set<ID> {
    return Set(this.contacts.map((contact) => String(contact.id)));
  }

  handleMergedContact(mergedIntoID: ID, mergedContactIDs: ID[]): Duplicate {
    let mergedIDs = Set(mergedContactIDs);

    if (!mergedIDs.intersect(this.contactIDs).size) {
      return this;
    }

    if (mergedIntoID) {
      mergedIDs = mergedIDs.remove(mergedIntoID);
    }

    return this.copyWith({
      contacts: this.contacts.filter(
        (contact) => mergedIntoID !== contact.id && !mergedIDs.has(String(contact.id)),
      ),
    });
  }

  handleArchivedContacts(archivedContactIDs: ID[]): Duplicate {
    const archivedIDs = Set(archivedContactIDs);

    if (!archivedIDs.intersect(this.contactIDs).size) {
      return this;
    }

    const filteredContacts = this.contacts.filter(
      (contact) => !archivedIDs.has(String(contact.id)),
    );

    if (filteredContacts.length < 2) {
      return this.copyWith({ isTransitioningOut: true });
    }

    return this.copyWith({ contacts: filteredContacts });
  }
}
